import script from "./CautionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CautionDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CautionDialog.vue?vue&type=style&index=0&id=0e9b8d82&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9b8d82"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn});
